import { Component, computed, input } from "@angular/core";
import { ProductType } from "../../../gql/generated-ingestor";
import { AddressType, Scalars } from "../../../gql/generated-ingestor";
import { StorageHelper } from "../../../helpers/storage/storagehelper";
import { getDetailRouterLink } from "../../../helpers/getDetailRouterLink";
import { AngularSvgIconModule } from "angular-svg-icon";
import { TranslateModule } from "@ngx-translate/core";
import { StatusToIconPipe } from "../../../helpers/statusiconpipe/statusiconpipe";
import { RouterLink } from "@angular/router";
import { GuidPipe } from "../../../helpers/guidpipe/guidpipe";
import { PortVisualiser } from "../port-visualiser/port-visualiser";

export interface PortTileSap {
  organisation?: string;
  vlanrange: string;
  port?: {
    tags: string[];
    product?: ProductType;
    subscriptionId: Scalars["ID"];
    customer?: {
      customerId: string;
    };
    customerDescription: string;
    address?: Partial<AddressType>;
  };
}

@Component({
  selector: "sap-tile",
  templateUrl: "sap-tile.html",
  styleUrls: ["../port-visualiser/port-visualiser.scss"],
  imports: [TranslateModule, AngularSvgIconModule, StatusToIconPipe, RouterLink, GuidPipe, PortVisualiser],
})
export class SapTile {
  protected sap = input.required<PortTileSap>();
  protected healthState = input.required<string>();

  protected showVisual = computed(() => this.port().customer?.customerId === StorageHelper.currentUser);

  protected port = computed(() => this.sap().port);
  protected customerDescription = computed(() => this.port()?.customerDescription);
  protected portId = computed(() => this.port().subscriptionId);
  protected tags = computed(() => this.port()?.tags);

  protected portOwner = computed(() => this.sap().organisation);
  protected serviceTag = computed(() => (this.sap() as any).serviceTag);
  protected vlanrange = computed(() => this.sap().vlanrange);
  protected showVlanrange = computed(() => this.vlanrange() && this.vlanrange() !== "0");

  private address = computed(() => this.port().address);
  protected city = computed(() => this.address()?.city);
  protected street = computed(() => this.address()?.street ?? "street");
  protected number = computed(() => this.address()?.number);

  protected routerLink = computed(() => [getDetailRouterLink(this.port(), this.port().product.type)]);
}
